import { Link } from "react-router-dom";
import type { ProcessingRequest } from "../api/types";
import { mopMetadata } from "../helpers/requestFamily";

export function MopRequestNotice({ request }: { request: ProcessingRequest }) {
  const mop = mopMetadata(request);
  const covered = request.classification?.flow_type === "mop";
  const uncovered = mop.coverage_status === "not_covered";
  return (
    <div className="alert alert-info" style={{ marginBottom: "var(--space-3)" }}>
      <strong>{covered ? "Copertura MOP trovata" : uncovered ? "Senza copertura MOP" : "Verifica MOP necessaria"}</strong>
      <span>{covered ? " — Uscita MOP preparata. " : uncovered
        ? " — Gestisci e approva la richiesta per creare il ticket RDI dell’impianto."
        : " — Verifica edificio, impianto e copertura prima di approvare la richiesta."}</span>
      {covered && <Link to={`/mop/${request.id}`}>Visualizza uscita</Link>}
    </div>
  );
}
